export const EVERYONE_LAST_ACTIVE_PERMISSION = "EVERYONE";
export const CONTACTS_LAST_ACTIVE_PERMISSION = "CONTACTS";
export const NONE_LAST_ACTIVE_PERMISSION = "NONE";
